var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecommended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M11.772 1.841a.66.66 0 0 0-.576.319l-1.02 1.617-1.805-.949a.674.674 0 0 0-.913.278.66.66 0 0 0-.076.319l.005 1.8-2.047-.008a.675.675 0 0 0-.676.673.7.7 0 0 0 .107.367l.977 1.52-1.713.89a.673.673 0 0 0 0 1.2l1.713.892-.976 1.517a.675.675 0 0 0 .209.931.66.66 0 0 0 .359.1l2.047-.008-.005 1.8a.67.67 0 0 0 .671.676.66.66 0 0 0 .319-.079l1.805-.956 1.02 1.624a.674.674 0 0 0 1.14 0l1.022-1.619 1.8.956a.674.674 0 0 0 .91-.28.65.65 0 0 0 .079-.321l-.01-1.8 2.047.01a.677.677 0 0 0 .681-.671.7.7 0 0 0-.11-.372l-.974-1.517 1.713-.892a.677.677 0 0 0 0-1.2l-1.711-.881.974-1.525a.674.674 0 0 0-.571-1.035l-2.042.01.005-1.8a.675.675 0 0 0-.673-.676.65.65 0 0 0-.316.079l-1.8.954-1.025-1.624a.67.67 0 0 0-.564-.319m-.01 2.7a4.724 4.724 0 1 1-4.719 4.724 4.75 4.75 0 0 1 4.719-4.727zm0 1.351a3.373 3.373 0 1 0 3.378 3.376 3.4 3.4 0 0 0-3.378-3.378zm-5.726 8.76H5.72l-2.621 4.209a.673.673 0 0 0 .224.925.68.68 0 0 0 .518.079l2.164-.557.548 2.256a.674.674 0 0 0 1.239.173l2.481-4.39a2 2 0 0 1-.219-.263l-.349-.566-.7.37a2.023 2.023 0 0 1-2.97-1.792zm11.457.005v.431a2.02 2.02 0 0 1-2.968 1.805l-.7-.372-.354.563a2 2 0 0 1-.219.263l2.476 4.39a.674.674 0 0 0 1.244-.173l.548-2.256 2.167.558a.674.674 0 0 0 .818-.49.66.66 0 0 0-.076-.515l-2.618-4.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended);
export default __webpack_public_path__ + "static/media/recommended.2ffca756.svg";
export { ForwardRef as ReactComponent };